import React, { useState, useEffect } from 'react';
import { FiSearch, FiCheckCircle, FiAlertCircle } from 'react-icons/fi';
import Modal from '../../../components/Modal';
import Input from '../../../components/Input';
import Button from '../../../components/Button';
import Api from '../../../Api';
import '../../../components/CompanyForm/style.css';
import './style.css';

export default function SelectInspectionModal({ isOpen, onClose, onSelect }) {
  const [loading, setLoading] = useState(false);
  const [inspections, setInspections] = useState([]);
  const [filteredInspections, setFilteredInspections] = useState([]);
  const [search, setSearch] = useState('');

  const [user] = useState(() => {
    try {
      return JSON.parse(localStorage.getItem('authUser'));
    } catch (e) {
      return null;
    }
  });

  const [companies, setCompanies] = useState([]);

  useEffect(() => {
    if (isOpen) {
      loadInspections();
    }
  }, [isOpen]);

  useEffect(() => {
    if (!inspections.length) {
      setFilteredInspections([]);
      return;
    }

    const lowerSearch = search.toLowerCase();
    const filtered = inspections.filter(ins => 
      ins.name.toLowerCase().includes(lowerSearch)
    );
    setFilteredInspections(filtered);
  }, [search, inspections]);

  async function loadInspections() {
    try {
      setLoading(true);
      const companiesData = await Api.getCompanies();
      const companyList = Array.isArray(companiesData) ? companiesData : (companiesData.data || []);
      setCompanies(companyList);

      const responses = await Promise.all(companyList.map(c => Api.getInspectionConfigs(c.id)));
      let merged = [];
      responses.forEach((configs, idx) => {
        const company = companyList[idx];
        const list = Array.isArray(configs) ? configs : (configs?.data || []);
        const annotated = list.map(conf => ({
          ...conf,
          company_id: company.id,
          company_name: company.corporate_name || company.trade_name || company.name || `Empresa ${company.id}`
        }));
        merged = merged.concat(annotated);
      });

      let availableInspections = [];
      // Allow superadmin (id=1), admins, and masters to see all templates
      if (user?.id === 1 || user?.role === 'admin' || user?.role === 'master' || user?.role === 'manager') {
        availableInspections = merged;
      } else {
        availableInspections = merged.filter(inspection => {
          // If no executors defined, maybe allow everyone or no one? 
          // Usually strict: if undefined, no one sees it except admins.
          if (!inspection.executors || inspection.executors.length === 0) return false;
          
          return inspection.executors.some(executor => {
            if (executor.entityId === 'all') return true;
            if (typeof executor === 'string' && executor === 'free') return true;
            
            // Check User ID
            if (executor.type === 'user' && String(executor.entityId) === String(user.id)) return true;
            
            // Check Employee ID (if user is linked to an employee)
            if (executor.type === 'employee' && user.employee_id && String(executor.entityId) === String(user.employee_id)) return true;
            
            return false;
          });
        });
      }

      setInspections(availableInspections);
      setFilteredInspections(availableInspections);
    } catch (error) {
      console.error('Error loading inspections:', error);
    } finally {
      setLoading(false);
    }
  }

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title="Nova Execução - Selecione o Modelo"
      size="md"
    >
      <div className="company-form-component">
        <div className="form-body">
          <div className="select-inspection-search" style={{ marginBottom: '1.5rem' }}>
             <Input
               icon={FiSearch}
               placeholder="Buscar inspeção..."
               value={search}
               onChange={e => setSearch(e.target.value)}
               noMargin
             />
          </div>

          <div className="select-inspection-list">
            {loading ? (
              <div className="loading-state">Carregando modelos...</div>
            ) : filteredInspections.length === 0 ? (
              <div className="empty-state" style={{display: 'flex', alignItems: 'center', gap: '10px'}}>
                <FiAlertCircle size={24} />
                <div>Nenhuma inspeção disponível para seu perfil.</div>
              </div>
            ) : (
              filteredInspections.map(inspection => (
                <button
                  key={`${inspection.id}-${inspection.company_id}`}
                  className="inspection-selection-card"
                  onClick={() => onSelect(inspection, inspection.company_id)}
                >
                  <div className="inspection-selection-info">
                     <div className="inspection-selection-color" style={{ backgroundColor: inspection.color || '#3B82F6' }} />
                     <span className="inspection-selection-name">
                       {inspection.name}
                       <span className="manager-table-subtitle" style={{ display: 'block' }}>
                         {inspection.company_name}
                       </span>
                     </span>
                  </div>
                  <FiCheckCircle className="inspection-selection-icon" />
                </button>
              ))
            )}
          </div>
        </div>

        <div className="form-actions">
          <Button
            type="button"
            className="cancel-button"
            onClick={onClose}
          >
            Cancelar
          </Button>
        </div>
      </div>
    </Modal>
  );
}
